<main>
  <loading-overlay [isLoading]="isLoading() > 0" />
  <p-toast position="top-center" />

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <div class="flex items-center gap-2">
          <h1>{{ 'ApprovalPolicies_Title' | translateWF: 'Approval policies' }}</h1>
          <i
            class="pi pi-info-circle text-color-secondary"
            tooltipPosition="bottom"
            [pTooltip]="
              'ApprovalPolicies_Note'
                | translateWF
                  : 'An inactive policy is never evaluated. Each document type has one default policy; a fund or trip may choose another that applies to that type. Changing a policy does not affect documents already submitted: their approvers were frozen when they were sent.'
            "
          ></i>
        </div>
        @if (canEdit) {
          <div class="page__title_buttons">
            <p-button [label]="'ApprovalPolicies_New' | translateWF: 'New policy'" icon="pi pi-plus" (onClick)="redirectToDetails(null)" />
          </div>
        }
      </div>
    </div>

    <p>{{ 'ApprovalPolicies_Subtitle' | translateWF: 'Who approves, in what order and from what amount.' }}</p>

    <div class="grid grid-cols-12 gap-[2rem]">
      <div class="col-span-12 md:col-span-3">
        @if (filterConfig(); as config) {
          <csl-dynamic-filters [filterConfig]="config" [state]="filterState" />
        }
      </div>

      <div class="col-span-12 md:col-span-9">
        <p-table [value]="policies()" [rowHover]="true" [lazy]="true" (onSort)="onSort($event)">
          <ng-template #header>
            <tr>
              <th pSortableColumn="name">
                {{ 'Name' | translateWF: 'Name' }}
                <p-sortIcon field="name" />
              </th>
              <th>{{ 'ApprovalPolicies_Composition' | translateWF: 'Composition' }}</th>
              <th pSortableColumn="minimumApprovals" class="text-right">
                {{ 'ApprovalPolicies_Minimum' | translateWF: 'Minimum' }}
                <p-sortIcon field="minimumApprovals" />
              </th>
              <th>{{ 'ApprovalPolicies_Order' | translateWF: 'Order' }}</th>
              <th>{{ 'ApprovalPolicies_Threshold' | translateWF: 'Threshold' }}</th>
              <th>{{ 'ApprovalPolicies_AppliesTo' | translateWF: 'Applies to' }}</th>
              <th>{{ 'ApprovalPolicies_DefaultFor' | translateWF: 'Default for' }}</th>
              <th pSortableColumn="isActive">
                {{ 'ApprovalPolicies_Status' | translateWF: 'Status' }}
                <p-sortIcon field="isActive" />
              </th>
            </tr>
          </ng-template>

          <ng-template #body let-policy>
            <tr>
              <td>
                <a class="cs-table-link" (click)="redirectToDetails(policy.id)">{{ localized(policy.name) }}</a>
              </td>
              <td>{{ composition(policy) }}</td>
              <td class="text-right tabular-nums">{{ policy.minimumApprovals }}</td>
              <td>
                @if (isSequential(policy)) {
                  {{ 'ApprovalPolicies_Sequential' | translateWF: 'Sequential' }}
                } @else {
                  {{ 'ApprovalPolicies_Parallel' | translateWF: 'Parallel' }}
                }
              </td>
              <td>
                @let from = threshold(policy);
                @if (from) {
                  {{ 'ApprovalPolicies_From' | translateWF: 'From' }} {{ from }}
                } @else {
                  —
                }
              </td>
              <td>{{ entityLabels(policy.appliesTo) }}</td>
              <td>
                <div class="flex flex-wrap gap-1">
                  @for (code of policy.defaultEntities; track code) {
                    <p-tag severity="info" [value]="entityLabel(code)" />
                  } @empty {
                    —
                  }
                </div>
              </td>
              <td>
                @if (policy.isActive) {
                  <p-tag severity="success" [value]="'ApprovalPolicies_Status_Active' | translateWF: 'Active'" />
                } @else {
                  <p-tag severity="secondary" [value]="'ApprovalPolicies_Status_Inactive' | translateWF: 'Inactive'" />
                }
              </td>
            </tr>
          </ng-template>

          <ng-template #emptymessage>
            <tr>
              <td colspan="8">{{ 'ApprovalPolicies_Empty' | translateWF: 'No approval policies found' }}</td>
            </tr>
          </ng-template>
        </p-table>

        <p-paginator
          [rows]="pageSize()"
          [totalRecords]="totalRecords()"
          [first]="(currentPage() - 1) * pageSize()"
          (onPageChange)="onPageChange($event)"
          [rowsPerPageOptions]="[25, 50, 100]"
        />
      </div>
    </div>
  </div>
</main>
